<template>
  <div class="changePassword">
    <Personal-center-head>
      <div>修改密码</div>
      <template slot="revert">
        <div class="revert">返回</div>
      </template>
    </Personal-center-head>

    <div class="content">
      <el-form
        label-width="80px"
        :model="ruleForm"
        label-position="top"
        :rules="rules"
        ref="ruleForm"
        size="small"
      >
        <div class="content-top">
          <el-form-item
            label="旧密码"
            prop="pastPass"
            style="width: 610px;"
          >
            <el-input
              type="password"
              clearable
              show-password
              v-model="ruleForm.pastPass"
              autocomplete="off"
              placeholder="请输入旧密码"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="新密码"
            clearable
            show-password
            prop="pass"
            style="width: 610px; margin: 40px 0px;"
          >
            <el-input
              type="password"
              clearable
              show-password
              v-model="ruleForm.pass"
              autocomplete="off"
              placeholder="请输入新密码"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item
          label="确认密码"
          prop="checkPass"
          style="width: 610px"
        >
          <el-input
            clearable
            show-password
            type="password"
            v-model="ruleForm.checkPass"
            autocomplete="off"
            placeholder="请再次输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item class="btn">
          <el-button
            style="background-color: #484c7f;color: #fff;"
            @click="submitForm('ruleForm')"
          >保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import PersonalCenterHead from '../../../components/PersonalCenterHead/index.vue'
export default {
  name: 'changePassword',
  components: {
    PersonalCenterHead,
  },
  data () {
    var validatePass1 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('旧密码不能为空'));
      }
      callback();
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        pass: '',
        checkPass: '',
        pastPass: ''
      },
      rules: {
        pass: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        pastPass: [
          { validator: validatePass1, trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    //提交
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getPassWord()
        } else {
          return false;
        }
      });
    },
    //修改密码 api
    async getPassWord () {
      const { data: data } = await this.$http.post("login/edit_pwd", {
        old_pwd: this.ruleForm.pastPass,//旧密码
        new_pwd: this.ruleForm.pass,//新密码
        confirm_pwd: this.ruleForm.checkPass,//确认密码
      })
      this.$message({
        message: data.message,
        type: 'success'
      });
      this.$Spin.show();
      setTimeout(() => {
        this.$Spin.hide();
        localStorage.removeItem("token");
        localStorage.removeItem("userinfo");
        this.$router.replace('/login')
      }, 1000);
    },
  }
}

</script>
<style lang="less" scoped>
.changePassword {
  padding: 0 0 50px 0;
  height: 97%;
  .content {
    position: relative;
    height: 100%;
    margin-top: 23px;
    padding: 25px 15px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    background-color: #fff;

    // .content-top {
    //   display: flex;
    // }
  }
  & /deep/ .el-form-item__label {
    font-size: 14px;
    color: #606266;
    padding-bottom: 15px;
    line-height: 16px;
    &::before {
      content: "*";
      color: #ff0000;
      padding-right: 5px;
      font-weight: 600;
    }
  }

  .btn {
    position: absolute;
    bottom: 0px;
    left: 15px;
  }
}
</style>